import { makeStyles, tokens } from '@fluentui/react-components';

export const useContractConceptCategoryListStyles = makeStyles({
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: tokens.spacingVerticalXL
  },
  rowActions: {
    display: 'flex',
    gap: tokens.spacingHorizontalS
  }
});
